import React from 'react';
import MarkdownWithViz from '../../MarkdownWithViz';

const reqPrefix = 'src/markdowns/revenue';
const req = require.context('!raw-loader!../../../markdowns/revenue', false, /\.(md|jsx)$/);

export default function Revenue() {
  return <MarkdownWithViz req={req} reqSource={req} reqPrefix={reqPrefix} />;
}
